"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobProgressIndicator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const Styled = __importStar(require("./JobProgressIndicator.styles"));
const JobProgressIndicator = ({ progress, size = 120, color = 'primary', showPercentage = true, showItemCount = true, className, jobResult, }) => {
    const progressValue = (0, react_1.useMemo)(() => {
        return Math.min(100, Math.max(0, progress.percentage));
    }, [progress.percentage]);
    const strokeWidth = Math.max(4, size * 0.043);
    const percentage = jobResult?.successfulPercentage ?? progressValue;
    const successfulProgress = jobResult?.successful ?? progress.current;
    return ((0, jsx_runtime_1.jsxs)(Styled.ProgressContainer, { "$size": size, className: className, children: [(0, jsx_runtime_1.jsx)(material_1.CircularProgress, { variant: "determinate", value: 100, size: size, thickness: strokeWidth, sx: {
                    color: (theme) => theme.palette.grey[300],
                    position: 'absolute',
                } }), (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { variant: "determinate", value: percentage, size: size, thickness: strokeWidth, color: color === 'error' ? undefined : color, sx: {
                    ...(color === 'error' && {
                        color: '#a6a6a6',
                    }),
                } }), (0, jsx_runtime_1.jsxs)(Styled.ProgressTextContainer, { "$size": size, children: [showPercentage && (0, jsx_runtime_1.jsxs)(Styled.PercentageText, { "$size": size, children: [Math.round(percentage), "%"] }), showItemCount && ((0, jsx_runtime_1.jsxs)(Styled.ItemCountText, { "$size": size, children: [successfulProgress.toLocaleString(), " / ", progress.total.toLocaleString()] }))] })] }));
};
exports.JobProgressIndicator = JobProgressIndicator;
